// extracted by mini-css-extract-plugin
export default {"title":"_3x-Nbqgu60","tall":"pBFKf9NmCy"};
    if(module.hot) {
      // 1643570386599
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  